import { Shield, Settings, AlertCircle, Download } from "lucide-react";

interface SalepageManagementProps {
  stats: any;
  navigate: (path: string) => void;
  handleExportData: () => void;
}

export default function SalepageManagement({ stats, navigate, handleExportData }: SalepageManagementProps) {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">จัดการ Subscription</h3>
            <p className="text-sm text-gray-500">อนุมัติและจัดการ subscription</p>
          </div>
        </div>
        <button
          onClick={() => navigate('/admin/payment-approval')}
          className="w-full mt-4 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors"
        >
          ไปที่หน้าอนุมัติ
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center">
            <Settings className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">ตั้งค่าระบบ</h3>
            <p className="text-sm text-gray-500">จัดการการตั้งค่าต่าง ๆ</p>
          </div>
        </div>
        <div className="mt-4 space-y-2">
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <span className="text-sm text-gray-700">ราคา Subscription</span>
            <span className="font-semibold text-gray-900">149 ฿/เดือน</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <span className="text-sm text-gray-700">ระยะเวลาทดลองใช้</span>
            <span className="font-semibold text-gray-900">7 วัน</span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
            <AlertCircle className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">รายการรอดำเนินการ</h3>
            <p className="text-sm text-gray-500">จำนวนรายการที่ต้องตรวจสอบ</p>
          </div>
        </div>
        <div className="mt-4 space-y-2">
          <div className="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
            <span className="text-sm text-gray-700">คำขอทดลองใช้</span>
            <span className="font-semibold text-yellow-700">{stats.pendingTrials}</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
            <span className="text-sm text-gray-700">การชำระเงินรอตรวจสอบ</span>
            <span className="font-semibold text-orange-700">{stats.pendingPayments}</span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-rose-500 to-red-500 rounded-xl flex items-center justify-center">
            <Download className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">Export ข้อมูล</h3>
            <p className="text-sm text-gray-500">ดาวน์โหลดรายงานเป็น CSV</p>
          </div>
        </div>
        <button
          onClick={handleExportData}
          className="w-full mt-4 px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white rounded-lg font-medium transition-colors"
        >
          Export ข้อมูลสถิติ
        </button>
      </div>
    </div>
  );
}
